"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputValue = void 0;
var React = __importStar(require("react"));
// Keeps track of the value of an input, while maintaining it uncontrolled
// https://reactjs.org/docs/uncontrolled-components.html
var useInputValue = function (_a) {
    var defaultValue = _a.defaultValue, valueProp = _a.value, onChangeProp = _a.onChange;
    var _b = React.useState(valueProp || defaultValue), value = _b[0], setValue = _b[1];
    var isMounting = React.useRef(true);
    React.useEffect(function () {
        if (isMounting.current) {
            isMounting.current = false;
            return;
        }
        setValue(valueProp);
    }, [valueProp]);
    var onChange = React.useCallback(function (event) {
        onChangeProp && onChangeProp(event);
        setValue(event.target.value);
    }, [onChangeProp]);
    return { value: value, onChange: onChange };
};
exports.useInputValue = useInputValue;
//# sourceMappingURL=useInputValue.js.map